// Curated list of common healthcare qualifications (India-oriented, extensible).
export const QUALIFICATIONS = [
  "MBBS",
  "MD General Medicine",
  "MD Cardiology",
  "MD Paediatrics",
  "MD Anaesthesia",
  "MD Radiology",
  "MD Dermatology",
  "MD Psychiatry",
  "MD Pathology",
  "MS General Surgery",
  "MS Orthopaedics",
  "MS ENT",
  "MS Ophthalmology",
  "MS Obstetrics & Gynaecology",
  "DM Cardiology",
  "DM Neurology",
  "MCh Neurosurgery",
  "MCh Urology",
  "DNB",
  "BDS",
  "MDS",
  "BSc Nursing",
  "MSc Nursing",
  "GNM (Nursing)",
  "ANM (Nursing)",
  "Post Basic BSc Nursing",
  "B.Pharm",
  "M.Pharm",
  "D.Pharm (Pharmacy)",
  "BPT (Physiotherapy)",
  "MPT (Physiotherapy)",
  "BMLT / DMLT (Lab Technology)",
  "B.Sc MLT",
  "BSc Radiography / Radiology Tech",
  "BOT / MOT (Occupational Therapy)",
  "B.Optom (Optometry)",
  "BASLP (Audiology & Speech)",
  "BNYS",
  "BAMS (Ayurveda)",
  "BHMS (Homeopathy)",
  "BUMS (Unani)",
  "BPH / MPH (Public Health)",
  "Hospital Administration (MHA)",
  "Diploma in Nursing",
  "Diploma in Medical Lab Technology",
  "First Aid / Patient Care Assistant",
];
